var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOffer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "b8f41442-fb79-44f8-aaa9-70ea6fd0bf45"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "26be8469-4952-466f-bd72-7742f425e3e4"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.89 0 0 1.89 540 540)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -222.49 63.53)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(249,159,27)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-63.17, -514.4)",
    d: "M 67.023 512.784 L 32.626999999999995 512.154 L 19.768999999999995 479.683 L 28.130999999999993 476.14799999999997 L 38.733999999999995 503.14399999999995 L 74.109 504.10699999999997 L 82.45599999999999 542.685 L 106.564 540.444 L 106.564 549.769 L 75.387 552.657 L 67.023 512.784 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 169.44 71.34)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(40,146,244)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-455.1, -522.21)",
    d: "M 479.847 482.99 L 477.293 498.422 L 460.883 502.603 L 457.996 520.604 L 440.308 519.3090000000001 L 436.142 539.2540000000001 L 420.066 540.5310000000002 L 413.313 559.4960000000002 L 420.066 561.7520000000002 L 425.525 547.5980000000002 L 443.21099999999996 546.6370000000002 L 446.43199999999996 527.0240000000001 L 464.74999999999994 528.3210000000001 L 467.63699999999994 508.70700000000016 L 483.39899999999994 504.84200000000016 L 485.96999999999997 490.39000000000016 L 496.888 490.05800000000016 L 496.258 482.6750000000002 L 479.847 482.99 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 145.9 -58.86)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(249,159,27)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-431.56, -392.02)",
    d: "M 413.069 373.859 C 433.011 373.859 450.052 390.251 450.052 410.17999999999995 L 450.052 410.17999999999995 L 413.069 410.17999999999995 L 413.069 373.859 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 229.79 -193.51)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(161,110,176)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-515.45, -257.37)",
    d: "M 499.325 266.066 L 504.192 257.13 L 499.611 248.043 C 499.09 247.008 499.978 245.822 501.115 246.036 L 511.093 247.917 L 518.2950000000001 240.741 C 519.1150000000001 239.924 520.5140000000001 240.40400000000002 520.662 241.555 L 521.961 251.65300000000002 L 530.992 256.305 C 532.021 256.834 531.997 258.318 530.953 258.814 L 521.7769999999999 263.17400000000004 L 520.1579999999999 273.225 C 519.973 274.37 518.5579999999999 274.80600000000004 517.7639999999999 273.96200000000005 L 510.7949999999999 266.55800000000005 L 500.7619999999999 268.119 C 499.62 268.298 498.771 267.084 499.325 266.066 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -86.58 -373.06)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,232,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-199.07, -77.82)",
    d: "M 182.705 78.957 C 182.07700000000003 69.89099999999999 188.89600000000002 62.029999999999994 197.93800000000002 61.39999999999999 C 206.978 60.770999999999994 214.81600000000003 67.61099999999999 215.44400000000002 76.67699999999999 C 216.07100000000003 85.744 209.251 93.60399999999998 200.211 94.23299999999999 C 191.169 94.864 183.332 88.023 182.705 78.957 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -80.29 -331.31)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,232,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-205.37, -119.57)",
    d: "M 210.532 125.427 C 209.55200000000002 120.653 208.959 115.542 207.336 110.941 C 205.93900000000002 106.98400000000001 199.782 108.19200000000001 200.09400000000002 112.44200000000001 C 200.47600000000003 117.646 202.09600000000003 122.92200000000001 203.18300000000002 128.02 C 203.62300000000002 130.084 206.348 131.042 208.15000000000003 130.40800000000002 C 210.354 129.632 210.957 127.501 210.532 125.427 L 210.532 125.427 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -56.53 -347.98)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,232,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-229.13, -102.9)",
    d: "M 238.652 105.04 C 233.214 101.82400000000001 228.474 97.83900000000001 223.45499999999998 94.037 C 219.535 91.066 215.30899999999997 96.179 218.534 99.709 C 223.164 104.78 229.244 108.742 235.113 112.212 C 236.97 113.31 239.552 112.23700000000001 240.459 110.40100000000001 C 241.476 108.343 240.515 106.141 238.652 105.04 L 238.652 105.04 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -46.94 -373.26)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,232,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-238.71, -77.62)",
    d: "M 228.353 75.581 C 227.12300000000002 76.572 226.875 77.995 227.636 79.378 C 229.475 82.724 234.14499999999998 82.558 237.459 82.445 C 240.919 82.327 244.38 81.622 247.65 80.502 C 252.48600000000002 78.847 249.864 71.32 245.012 72.981 C 235.521 76.23 231.926 72.704 228.353 75.581 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -63.15 -399.87)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,232,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-222.5, -51)",
    d: "M 223.127 43.583 C 218.352 50.589999999999996 214.449 52.955999999999996 215.056 56.813 C 215.412 59.068000000000005 217.18900000000002 60.144000000000005 219.36100000000002 59.651 C 221.92600000000002 59.067 223.323 56.339000000000006 224.86 54.42400000000001 C 226.335 52.58800000000001 227.782 50.748000000000005 229.09900000000002 48.79200000000001 C 230.293 47.01800000000001 230.46200000000002 44.72100000000001 228.711 43.19300000000001 C 227.244 41.913 224.34 41.803 223.127 43.583 L 223.127 43.583 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -85.78 -410.16)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,232,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-199.88, -40.72)",
    d: "M 204.521 42.368 C 202.993 38.121 202.658 36.576 200.678 34.602000000000004 C 198.957 32.887 195.322 33.981 195.082 36.508 C 194.802 39.456 195.417 40.551 197.022 45.013000000000005 C 197.75 47.038000000000004 200.05499999999998 48.167 202.09 47.45100000000001 C 204.109 46.741 205.251 44.4 204.521 42.368 L 204.521 42.368 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -107.6 -398.06)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,232,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-178.06, -52.81)",
    d: "M 184.423 52.646 C 177.538 47.4 176.139 45.923 173.433 46.209 C 171.84799999999998 46.376000000000005 170.06699999999998 47.903000000000006 170.41299999999998 49.689 C 171.057 53.005 172.98 53.906 179.30999999999997 58.538 C 181.009 59.779999999999994 183.33999999999997 59.842999999999996 184.80399999999997 58.156 C 186.116 56.643 186.104 53.927 184.423 52.646 L 184.423 52.646 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -118.37 -372.89)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,232,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-167.28, -77.99)",
    d: "M 156.769 76.69 C 154.056 78.133 155.14600000000002 82.838 158.084 83.223 C 160.9 83.592 161.988 83.138 175.655 80.636 C 177.766 80.25 179.505 78.704 179.344 76.38499999999999 C 179.208 74.41699999999999 177.231 72.30099999999999 175.105 72.68499999999999 C 160.912 75.253 159.491 75.242 156.769 76.69 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -109.94 -344.78)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,232,56)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-175.72, -106.09)",
    d: "M 178.182 99.114 C 170.69 106.384 169.594 105.101 166.637 109.547 C 165.284 111.58 167.514 114.82 169.87 114.387 C 172.892 113.831 173.705 113.32000000000001 177.644 110.189 C 179.934 108.36999999999999 182.12300000000002 106.41999999999999 184.226 104.38799999999999 C 185.785 102.88199999999999 185.364 100.056 183.834 98.71999999999998 C 182.084 97.193 179.742 97.6 178.182 99.114 L 178.182 99.114 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 263.32 -369.32)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(108,94,129)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    points: "-14.95,2.79 14.95,13.41 7.19,-13.41 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 99.26 -406.65)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(187,214,49)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    points: "2.71,-1.13 -22.07,-1.66 -31.27,-25.24 -25.12,-27.66 -17.52,-8.19 8.08,-7.64 14.09,20.46 31.15,18.72 31.27,25.38 8.87,27.66 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 42.08 -104.51)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(247,164,145)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-327.74, -346.37)",
    d: "M 342.618 320.866 C 342.618 320.866 340.223 332.64099999999996 338.323 336.972 C 337.32399999999996 339.248 332.926 348.019 332.926 348.019 L 330.877 371.866 L 312.855 369.473 C 312.855 369.473 318.957 352.288 316.889 347.129 C 315.26300000000003 343.06600000000003 314.255 334.54900000000004 314.35900000000004 332.41900000000004 C 314.711 325.157 342.618 320.866 342.618 320.866 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -138.59 -94.52)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(247,164,145)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-147.06, -356.35)",
    d: "M 117.885 335.412 C 117.885 335.412 136.15800000000002 347.20799999999997 139.666 350.40599999999995 C 141.511 352.0849999999999 149.118 358.34099999999995 149.118 358.34099999999995 L 160.742 379.32199999999995 L 176.242 369.90099999999995 C 176.242 369.90099999999995 163.63799999999998 356.638 163.417 351.09099999999995 C 163.244 346.72399999999993 160.682 338.53299999999996 159.716 336.62699999999995 C 156.424 330.126 117.885 335.412 117.885 335.412 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -32.93 -12.79)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-252.72, -438.09)",
    d: "M 263.651 408.325 C 263.651 408.325 254.262 398.518 246.71 410.449 C 246.71 410.449 240.894 407.213 236.811 412.976 C 236.811 412.976 226.3 409.842 223.74800000000002 425.413 C 223.74800000000002 425.413 218.33900000000003 424.402 217.62500000000003 430.772 C 216.91100000000003 437.14099999999996 220.17700000000002 441.388 220.17700000000002 441.388 C 220.17700000000002 441.388 217.13700000000003 443.645 218.51800000000003 449.501 C 219.69200000000004 454.47999999999996 223.85100000000003 455.239 223.85100000000003 455.239 C 223.85100000000003 455.239 224.97300000000004 463.63199999999995 228.64700000000002 466.159 C 232.321 468.68600000000004 237.32200000000003 467.472 237.32200000000003 467.472 C 237.32200000000003 467.472 238.64900000000003 472.02299999999997 242.93400000000003 471.618 C 247.22100000000003 471.214 252.52700000000002 467.17 257.32500000000005 468.989 C 262.12000000000006 470.80899999999997 274.571 468.888 274.571 468.888 C 274.571 468.888 288.552 462.721 284.36800000000005 448.566 C 284.36800000000005 448.566 291.71600000000007 441.99399999999997 285.28600000000006 434.10699999999997 C 285.28600000000006 434.10699999999997 289.98100000000005 421.77299999999997 280.69500000000005 414.493 C 271.407 407.213 263.651 408.325 263.651 408.325 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -142.75 311.48)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(247,164,145)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-142.91, -762.35)",
    d: "M 159.309 754.707 C 159.309 754.707 143.12199999999999 752.876 140.44 751.568 C 137.758 750.264 124.169 763.122 126.865 769.571 C 128.38299999999998 773.205 133.184 772.741 133.184 772.741 L 137.065 768.986 L 157.605 773.228 L 159.309 754.707 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -31.54 389.12)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(247,164,145)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-254.12, -839.99)",
    d: "M 251.689 822.286 C 251.689 822.286 243.166 836.04 240.837 837.895 C 238.50799999999998 839.749 244.518 857.389 251.55499999999998 857.698 C 255.52299999999997 857.8729999999999 257.12899999999996 853.367 257.12899999999996 853.367 L 255.33699999999996 848.293 L 267.907 831.651 L 251.689 822.286 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -38.59 410.39)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-247.06, -861.27)",
    d: "M 241.35 837.355 C 241.35 837.355 246.24699999999999 843.543 248.91899999999998 846.003 C 252.368 849.183 256.78499999999997 852.288 256.78499999999997 852.288 C 256.78499999999997 852.288 261.787 861.285 263.154 864.423 C 266.198 871.41 269.617 879.197 269.125 883.109 C 268.967 884.366 266.119 885.696 263.745 884.971 C 253.865 881.963 228.603 859.068 225.414 852.921 C 221.735 845.834 241.35 837.355 241.35 837.355 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -2.63 279.49)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(40,172,226)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-283.03, -730.37)",
    d: "M 313.457 627.845 C 312.539 625.301 311.659 622.948 310.80899999999997 620.735 C 300.30199999999996 623.008 288.43199999999996 625.506 276.22299999999996 628.085 L 274.73599999999993 672.424 C 274.7439999999999 668.9979999999999 283.9149999999999 743.1419999999999 283.9149999999999 743.1419999999999 C 283.9149999999999 743.1419999999999 258.9729999999999 792.222 242.7479999999999 822.5519999999999 C 249.4079999999999 830.7849999999999 254.52399999999992 834.3899999999999 264.1679999999999 840.0009999999999 C 289.3579999999999 810.0849999999998 321.5459999999999 757.3549999999999 322.9149999999999 748.2509999999999 C 323.701 743.012 324.41 658.376 313.457 627.845 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -73.59 250.98)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(40,172,226)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-212.07, -701.85)",
    d: "M 219.667 640.668 C 222.524 671.403 227.247 717.9300000000001 228.109 733.585 C 208.053 736.4490000000001 160.66500000000002 750.5690000000001 151.83 750.5550000000001 C 148.488 757.9770000000001 146.63600000000002 766.9870000000001 148.955 774.3870000000001 C 149.413 775.8480000000001 242.43400000000003 778.7840000000001 266.446 763.604 C 272.71000000000004 759.643 274.639 717.192 274.735 672.423 L 276.22200000000004 628.0840000000001 C 255.881 632.381 237.175 636.594 219.667 640.668 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -16.85 115.47)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(187,214,49)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-268.81, -566.34)",
    d: "M 286.47 483.184 L 263.644 486.591 C 263.644 486.591 246.43900000000002 486.857 241.845 486.90000000000003 C 241.447 486.90400000000005 223.539 573.446 219.186 606.0160000000001 C 214.832 638.5840000000001 218.205 644.3510000000001 218.205 644.3510000000001 C 218.205 644.3510000000001 248.565 651.1170000000001 271.026 649.1430000000001 C 294.38300000000004 647.0940000000002 320.66200000000003 634.6000000000001 320.66200000000003 634.6000000000001 C 320.66200000000003 634.6000000000001 299.211 571.1240000000001 295.254 551.5830000000001 C 291.295 532.041 286.47 483.184 286.47 483.184 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 12.85 50.89)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-298.5, -501.77)",
    d: "M 333.399 362.421 C 333.399 362.421 331.396 442.594 328.939 447.53 C 325.368 454.70899999999995 299.834 505.893 299.834 505.893 C 299.834 505.893 319.041 585.53 327.117 613.0319999999999 C 327.93 615.8009999999999 331.529 633.6899999999999 331.529 635.434 C 331.529 639.302 314.537 644.2099999999999 312.52 643.92 C 310.714 643.659 295.889 567.905 286.424 530.837 C 283.21599999999995 518.275 277.715 506.406 270.188 495.811 L 263.60499999999996 486.54499999999996 L 302.61899999999997 439.77 C 302.61899999999997 439.77 311.063 365.746 311.063 361.12 C 311.064 359.906 330.95 357.871 333.399 362.421 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -80.7 58.66)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-204.96, -509.54)",
    d: "M 241.845 486.902 L 202.756 428.5 C 202.756 428.5 177.388 367.145 176.765 364.879 C 176.153 362.654 156.208 365.19800000000004 149.904 364.589 C 147.882 364.394 176.464 429 179.47899999999998 439.76800000000003 C 183.041 452.49 202.11899999999997 502.26300000000003 202.11899999999997 502.26300000000003 C 202.11899999999997 502.26300000000003 215.30299999999997 532.065 213.24699999999996 555.094 C 209.83099999999996 593.341 203.05799999999996 648.4570000000001 204.70599999999996 650.109 C 214.94299999999996 656.498 247.15699999999995 656.268 249.64399999999995 652.2990000000001 C 277.106 608.483 241.845 486.902 241.845 486.902 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -32.15 31.34)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(247,164,145)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-253.51, -482.21)",
    d: "M 262.064 474.909 L 263.764 487.4 C 263.764 487.4 267.572 505.39799999999997 262.673 508.86699999999996 C 257.776 512.336 241.844 486.888 241.844 486.888 L 243.527 455.23499999999996 L 262.064 474.909 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -32.41 19.49)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(244,116,88)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-253.24, -470.37)",
    d: "M 242.983 465.491 C 247.028 476.288 256.666 482.926 263.50600000000003 485.49899999999997 L 262.064 474.909 L 243.526 455.234 L 242.983 465.491 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -62.02 -17.15)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    cx: 0,
    cy: 0,
    rx: 6.181,
    ry: 8.729
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -42.13 -35.92)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    cx: 0,
    cy: 0,
    rx: 7.521,
    ry: 5.018
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -27.34 -0.29)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(247,164,145)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-258.32, -450.59)",
    d: "M 254.846 421.978 C 264.786 418.588 275.382 425.13 276.898 435.281 C 277.55800000000005 439.694 278.154 445.242 278.266 451.309 C 278.533 465.90000000000003 270.909 480.09900000000005 264.22200000000004 480.09900000000005 C 257.5350000000001 480.09900000000005 239.05300000000003 470.65400000000005 238.38400000000004 449.94000000000005 C 237.97 437.151 244.415 425.535 254.846 421.978 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -47.16 0.7)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(247,164,145)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    cx: 0,
    cy: 0,
    rx: 4.81,
    ry: 5.828
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -8.94 -27.57)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-276.72, -423.3)",
    d: "M 283.817 414.718 C 290.725 420.14000000000004 293.145 428.377 289.224 433.117 C 285.30199999999996 437.858 276.524 437.305 269.616 431.884 C 262.70799999999997 426.463 260.287 418.225 264.209 413.485 C 268.131 408.744 276.91 409.296 283.817 414.718 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -26.31 -31.71)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    cx: 0,
    cy: 0,
    rx: 6.414,
    ry: 4.267
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -6.29 -13.58)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    cx: 0,
    cy: 0,
    rx: 5.475,
    ry: 5.485
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -162.16 318.62)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-123.5, -769.5)",
    d: "M 141.15 751.802 C 141.15 751.802 137.565 758.816 136.443 762.254 C 134.994 766.696 134.024 771.976 134.024 771.976 C 134.024 771.976 127.914 780.27 125.621 782.828 C 120.518 788.516 114.27199999999999 795.247 110.48599999999999 796.458 C 109.27099999999999 796.848 105.81799999999998 795.824 105.85099999999998 793.169 C 105.97699999999999 782.93 115.89999999999998 749.547 120.17199999999998 744.082 C 125.097 737.779 141.15 751.802 141.15 751.802 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -141.92 -105.48)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(244,116,88)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-143.74, -345.39)",
    d: "M 133.156 342.288 C 133.156 342.288 137.897 347.598 143.59900000000002 348.414 C 149.30200000000002 349.231 154.318 343.377 154.318 343.377 L 133.156 342.288 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 41.63 -119.52)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(244,116,88)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-327.29, -331.36)",
    d: "M 315.955 332.315 L 316.96799999999996 333.856 C 316.96799999999996 333.856 332.24999999999994 334.397 338.628 328.843 L 315.955 332.315 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -57.82 -201.52)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(40,172,226)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-227.83, -249.35)",
    d: "M 40.327 179.014 C 163.083 194.346 288.805 185.294 410.871 152.335 C 421.265 203.93800000000002 431.65799999999996 255.541 442.05199999999996 307.144 C 300.91499999999996 345.252 155.551 355.718 13.617999999999938 337.99 C 22.521 284.998 31.424 232.006 40.327 179.014 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -58.22 -197.98)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-227.44, -252.9)",
    d: "M 408.51 183.611 C 414.738 215.887 420.965 248.164 427.192 280.44 C 414.336 283.803 405.458 295.738 407.41200000000003 307.437 C 288.713 335.718 167.455 344.448 48.195 333.3 C 49.813 321.345 40.613 310.711 27.686 309.204 C 32.982 276.098 38.277 242.99200000000002 43.573 209.88600000000002 C 55.469 211.27100000000002 66.451 202.45300000000003 68.06700000000001 190.50600000000003 C 172.79500000000002 200.29600000000002 279.278 192.63000000000002 383.514 167.79500000000002 C 385.468 179.484 396.678 186.704 408.51 183.611 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -67.1 -183.81)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(40,172,226)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-218.56, -267.06)",
    d: "M 161.036 269.118 C 162.704 238.764 188.287 214.187 218.191 212.243 C 248.096 210.37199999999999 273.975 231.667 276.04 261.783 C 278.11 291.843 252.556 319.731 218.91200000000003 321.85900000000004 C 185.267 324.023 159.361 299.417 161.036 269.118 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -68.64 -186.57)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-217.02, -264.3)",
    d: "M 221.215 221.597 C 221.333 224.87300000000002 221.451 228.148 221.571 231.424 C 226.095 231.204 230.561 231.59300000000002 234.276 232.37800000000001 C 237.375 233.03400000000002 239.3 235.96800000000002 238.66000000000003 239.10600000000002 C 238.63500000000002 239.23200000000003 238.60900000000004 239.35800000000003 238.58300000000003 239.485 C 237.87700000000004 242.942 234.31800000000004 245.28 230.87600000000003 244.5 C 227.37200000000004 243.706 223.41000000000003 243.301 219.24500000000003 243.677 C 213.18200000000004 244.22299999999998 209.08200000000002 246.82399999999998 209.18200000000004 250.968 C 209.28100000000003 254.897 212.77800000000005 257.131 220.86200000000005 258.99399999999997 C 232.54100000000005 261.65999999999997 240.75000000000006 265.909 241.31700000000006 275.928 C 241.83400000000006 285.001 235.35900000000007 292.931 223.48000000000008 296.22 C 223.60800000000006 299.495 223.73800000000008 302.77000000000004 223.86800000000008 306.045 C 220.18900000000008 306.386 216.50800000000007 306.709 212.8280000000001 307.012 C 212.73700000000008 303.976 212.6460000000001 300.94 212.5560000000001 297.904 C 208.48800000000008 298.07 205.1330000000001 297.819 202.3260000000001 297.332 C 198.8920000000001 296.735 196.82200000000012 293.614 197.6450000000001 290.382 L 197.6450000000001 290.382 C 198.4990000000001 287.039 202.0790000000001 284.85200000000003 205.5630000000001 285.545 C 208.1780000000001 286.065 211.4080000000001 286.384 215.3140000000001 286.051 C 222.5080000000001 285.43 224.7100000000001 282.296 224.5910000000001 279.406 C 224.4570000000001 275.985 220.51700000000008 274.211 211.1400000000001 271.665 C 198.0220000000001 268.35900000000004 192.7800000000001 262.923 192.6890000000001 253.61 C 192.6120000000001 244.372 199.2290000000001 236.11700000000002 211.2710000000001 233.05700000000002 C 211.1770000000001 229.537 211.0830000000001 226.01600000000002 210.9910000000001 222.496 C 214.399 222.213 217.808 221.914 221.215 221.597 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 51.44 -194.12)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(40,172,226)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-337.1, -256.76)",
    d: "M 292.622 256.824 C 321.587 252.887 350.48 247.727 379.226 241.35000000000002 C 380.011 246.39100000000002 380.795 251.43200000000002 381.579 256.473 C 352.43 262.939 323.13100000000003 268.171 293.761 272.163 C 293.382 267.05 293.002 261.938 292.622 256.824 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -184.12 -178.99)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(40,172,226)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-101.54, -271.88)",
    d: "M 59.214 262.003 C 88.042 264.667 116.994 266.09299999999996 145.997 266.289 C 145.692 271.44599999999997 145.388 276.604 145.08300000000003 281.76099999999997 C 115.67400000000004 281.56199999999995 86.31600000000003 280.11499999999995 57.08400000000003 277.414 C 57.794 272.278 58.503 267.14 59.214 262.003 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -128.7 -111.87)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(247,164,145)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-156.96, -339)",
    d: "M 151.295 347.053 C 151.295 347.053 155.69299999999998 343.207 155.975 337.302 C 156.009 336.565 153.97899999999998 329.97400000000005 156.536 329.528 C 160.787 328.78700000000003 162.626 348.493 162.626 348.493 C 162.626 348.493 156.69 346.399 151.295 347.053 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 46.97 -122.98)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(247,164,145)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-332.63, -327.9)",
    d: "M 322.643 339.36 C 322.643 339.36 334.628 328.45500000000004 337.29999999999995 323.168 C 337.63399999999996 322.509 338.472 315.668 340.99099999999993 316.286 C 345.1809999999999 317.315 339.9549999999999 332.171 339.9549999999999 332.171 C 339.9549999999999 332.171 327.842 340.927 322.643 339.36 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -21.62 17.6)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-264.04, -468.47)",
    d: "M 270.543 465.798 L 257.53000000000003 466.101 C 257.53000000000003 466.101 257.947 471.113 263.67600000000004 471.148 C 270.657 471.189 270.543 465.798 270.543 465.798 z",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffer);
export default __webpack_public_path__ + "static/media/offer.d35a0efe872a3a00f0fa7a4b20112443.svg";
export { ForwardRef as ReactComponent };